// src/stores/dialogStore.ts
import { create } from 'zustand';
import { SwalLeaveConfirm } from '../../components/dialog/swal_alert';


interface DialogState {
    isOpen: boolean;
    openDialog: () => void;
    closeDialog: () => void;
}

export const useDialogState = create<DialogState>((set) => ({
    isOpen: false,
    openDialog: () => set({ isOpen: true }),
    closeDialog: () => set({ isOpen: false }),
}));


export const leaveGuardConfig = () => SwalLeaveConfirm(
    () => () => {
        return useDialogState.getState().closeDialog();
    },
    () => useDialogState.getState().closeDialog(),
    () => { }
)